import type {
    DetailPaneContent,
    DetailPaneLoadState,
    DetailPaneMailLoadErrorDetails,
    MyOutlookAugLoopTarget,
    TodayOpxCapability,
    TodayOpxMockMode,
} from 'owa-personal-os-types';
import { BASELINE_TODAY_OPX_CAPABILITIES } from 'owa-personal-os-types';
import { createStore } from 'owa-satcheljs';
import type { TodayClientFreshnessState } from 'owa-personal-os-service/lib/MyOutlookClient';
import type { MyOutlookBriefingSource } from '@augloop-types/my-outlook';

export interface PersonalOSStore {
    myOutlookAugLoopTargetsByAccount: Record<string, MyOutlookAugLoopTarget>;
    myOutlookBriefingSourcesByAccount: Record<string, MyOutlookBriefingSource>;
    todayOpxCapabilities: TodayOpxCapability[];
    todayOpxMockMode: TodayOpxMockMode | null;
    todayDocumentReloading: boolean;
    todayClientFreshness: TodayClientFreshnessState;
    todayHostLifecycle: { visible: boolean | null; reloadBlocked: boolean };
    pastedBriefingOverride: { contextKey: string; json: string } | null;
    detailPaneContent: DetailPaneContent | null;
    detailPaneOwnerKey: string | null;
    detailPaneInstanceId: number | null;
    detailPaneLoadState: DetailPaneLoadState;
    detailPaneMailLoadError:
        | {
              contentId: string;
              loadId: number;
              errorDetails: DetailPaneMailLoadErrorDetails;
          }
        | undefined;
}

const getStore: () => PersonalOSStore = createStore<PersonalOSStore>('PersonalOSStore', {
    myOutlookAugLoopTargetsByAccount: {},
    myOutlookBriefingSourcesByAccount: {},
    todayOpxCapabilities: [...BASELINE_TODAY_OPX_CAPABILITIES],
    todayOpxMockMode: null,
    todayDocumentReloading: false,
    todayClientFreshness: { phase: 'current' },
    todayHostLifecycle: { visible: null, reloadBlocked: true },
    pastedBriefingOverride: null,
    detailPaneContent: null,
    detailPaneOwnerKey: null,
    detailPaneInstanceId: null,
    detailPaneLoadState: { state: 'NotLoaded' },
    detailPaneMailLoadError: undefined,
});

export default getStore;
